import React, { Component } from 'react';

import Modal from 'components/modals/Modal';
import propTypes from 'prop-types';
import accountPropTypes from 'apps/account/propTypes';
import { TranslatedMessage } from 'common/components/Intl';
import SubscriptionCommitModalFooter from './SubscriptionCommitModalFooter';

export default class CommitmentUpsellModal extends Component {
  static propTypes = {
    variantName: propTypes.string.isRequired,
    minimumPodPacks: propTypes.number.isRequired,
    offering: accountPropTypes.VariantOffering.isRequired,
    handleClose: propTypes.func.isRequired,
    reportEvergreenOffering: propTypes.func.isRequired,
    cancellationFee: propTypes.string.isRequired,
    isOpen: propTypes.bool.isRequired,
  };

  componentDidMount() {
    this.props.reportEvergreenOffering(this.props.offering);
  }

  render() {
    const {
      variantName,
      minimumPodPacks,
      handleClose,
      isOpen,
      offering,
      cancellationFee,
    } = this.props;
    const { requiredInstallmentCount } = offering.commitmentReward;
    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={handleClose}
        bodyClassName="Modal__body--large container"
      >
        <h2>
          <TranslatedMessage
            id={'cart.commitment_upsell_modal.header'}
            values={{ variantName }}
          />
        </h2>
        <p>
          <TranslatedMessage
            id={'cart.commitment_upsell_modal.intro'}
            values={{ variantName }}
          />
        </p>
        <p>
          <TranslatedMessage
            id={'cart.commitment_upsell_modal.details'}
            values={{
              variantName,
              requiredInstallmentCount,
              minimumPodPacks,
              cancellationFee,
            }}
          />
        </p>
        <SubscriptionCommitModalFooter
          onClose={handleClose}
          onAccept={handleClose}
          offering={offering}
          variantName={variantName}
          acceptTranslationId="cart.commitment_upsell_modal.accept"
          dismissTranslationId="cart.commitment_upsell_modal.dismiss"
        />
      </Modal>
    );
  }
}
